import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IDownloadDocumentRequest } from '../models/download-document.model';

export const loadDownloadDocuments = createAction(
  '[DownloadDocument] Load DownloadDocuments',
  props<{ request: IDownloadDocumentRequest }>()
);

export const loadDownloadDocumentsSuccess = createAction(
  '[DownloadDocument] Load DownloadDocuments Success',
  props<{ response: string }>()
);

export const loadDownloadDocumentsFailure = createAction(
  '[DownloadDocument] Load DownloadDocuments Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
